import { FEATURE_FLAGS, isFeatureFlagEnabled } from '@/shared-measurement';
import type { EmbedProbe } from '@/shared-responder-v2-media';

import { toEmbedProbeResultFromResponse } from './shared-responder-v2-gateway-embed-probe.helpers';

const IFRAME_CHECK_API_PATH = '/survey/api/check-iframe-embeddable';

export function createSurveyEmbedProbe(baseUrl: string): EmbedProbe {
  return async (url) => {
    if (!isFeatureFlagEnabled(FEATURE_FLAGS.HYPERBEAM_FEATURE)) {
      return { canEmbed: true, reason: null };
    }

    try {
      const response = await fetch(
        `${baseUrl}${IFRAME_CHECK_API_PATH}?url=${encodeURIComponent(url)}`
      );

      let body: unknown;
      try {
        body = await response.json();
      } catch {
        return { canEmbed: true, reason: null };
      }

      return toEmbedProbeResultFromResponse(response.ok, body);
    } catch {
      return { canEmbed: true, reason: null };
    }
  };
}
